import BackButtonClient, {
  BackButtonProps,
} from '@/src/components/BackButton/BackButtonClient.tsx'

const BackButton = async (props: BackButtonProps) => {
  return <BackButtonClient {...props} />
}

export default BackButton
